import React, {CSSProperties, MouseEvent, ReactElement} from 'react';
import { FaCheck } from 'react-icons/fa';

import './../checkBox.scss'

interface ICheckBoxLayoutProps {
  checked: boolean
  style?: CSSProperties
  className?: string
  disabled?: boolean
  onClick: ()=>void
  icon?: ReactElement
  radio?: boolean
  label?: string
  id?: string;
}

const CheckBoxLayout: React.FC<ICheckBoxLayoutProps> = (props) => {

  const handleClick = (e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => {
    e.stopPropagation()
    if(props.disabled)return
    props.onClick && props.onClick()
  }

    return (
      <div className='check_box-wrapper'>
        <div
          className={`check_box-component ${props.className ? props.className : ''} ${props.checked ? 'active' : ''} ${props.disabled ? 'disabled' : ''} ${props.radio ? 'radio' : ''}`}
          style={props.style ?? {}}
          onClick={handleClick}
        >
          {props.icon ? props.icon : <FaCheck className='icon-done' />}
        </div>
        {props.label && (
          <label className='check_box-label form-check-label' htmlFor={props.id}>{props.label}</label>
        )}
      </div>
    );
};

export default CheckBoxLayout;
